import { render, staticRenderFns } from "./DesignFoundationsWritings.vue?vue&type=template&id=383138da"
import script from "./DesignFoundationsWritings.vue?vue&type=script&lang=js"
export * from "./DesignFoundationsWritings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports